// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';
import Sidebar from './Menu';
import { Box } from '@mui/material';
import MainLayout from './MainLayout';
import MediaQuery from 'react-responsive';

const PrivateRoute = ({ ...props }) => {
  // const auth = localStorage.getItem('token');

  const auth = 
    localStorage?.getItem('phone') && localStorage?.getItem('roles')
      ? true
      : false;

  return (
    <MediaQuery minWidth={800}>
      {(matches) => {
        return (
          <>
            <MainLayout {...props} showToggle={!matches}>
              {auth ? <Outlet /> : <Navigate to='/login' />}
            </MainLayout>
          </>
        );
      }}
    </MediaQuery>
  );
};

export default PrivateRoute;
